import React from 'react'
import {BiMinus,BiPlus} from 'react-icons/bi'

const IncDecrement = ({productCount, setProductCount}) => {

    const decrement = () => {
        if(productCount == 1) return;
        setProductCount(productCount - 1)
    }

    const increment = () => {
        setProductCount(productCount + 1)
    }

  return (
    <div className='incdecrement'>
      <BiMinus onClick={decrement} size={25}/>  
      <div>{productCount || 1}</div>
      <BiPlus onClick={increment} size={25}/>
    </div>
  )
}

export default IncDecrement